module.exports = __webpack_public_path__ + "img/potenza-sport.8331eeff.png";